import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/app/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  endpoint:any;
  constructor(private http: HttpClient, private configService: ConfigService) {
    this.endpoint = this.configService.endpoints;
   }

  userLogIn(data) {
    return this.http.post<any>(`${this.endpoint.LogInAPIEndpoint}/login/userlogin`, data);
  }

  userLogOut() {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/User/logout`, {});
  }

  getIPAddress() {
    return this.http.get("https://api64.ipify.org/?format=json");
  }

}
